<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import persistTableFilters from "@/mixins/persistTableFilters";
import {required} from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import {FulfillingBouncingCircleSpinner} from "epic-spinners";
import vSelect from "vue-select";
import moment from 'moment';
import "vue-select/dist/vue-select.css";
// import moment from "moment";
// import Switches from "vue-switches";
import Datepicker from 'vuejs-datepicker';
// import DatePicker from "vue2-datepicker";
import {es} from 'vuejs-datepicker/dist/locale';
Vue.component("v-select", vSelect);
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";

// register the plugin on vue
import Toasted from "vue-toasted";

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Departamento component
 */
export default {
  mixins: [persistTableFilters],
  persistConfig: {
    key: "traslados_filtros",
    fields: ["search", "perPage", "searchLabel", "filterLabel",
             "fecha_inicio", "fecha_fin", "rangode_fecha", "tipo_label"],
  },
  page: {
    title: "Traslados",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    datepicker: Datepicker,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    // Switches,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // DatePicker,
  },
  data() {
    return {
      es :es,
      disabledDates: {
          to: '',
      },
      swAnular: false,
      tipo_label: {nombre: "Pendientes de pago", value: 0},
      tipo_array: [
        {nombre: "Pendientes de pago", value: 0},
        {nombre: "Pagados", value: 1},
      ],
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {"x-token": this.$store.state.authfack.user.token},
      },
      metododeBusqueda: false,
      fecha_inicio: "",
      rangode_fecha: "",
      fecha_fin: "",
      bandera_fecha: false,
      repit: true,
      arrayBodegas: [],
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "traslados/get?tienda="+this.$store.state.authfack.user.tienda,
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      formVenta: {
        total: "",
        cliente: "",
        nombre: "",
        descripcion: "",
        tiendaid: "",
        state: true,
        id: 0,
      },
      tiendasData: [],
      updating: false,
      estadotabla: true,
      title: "Traslados",
      itemst: [
        {
          text: "Traslados",
          href: "/",
        },
        {
          text: "Listado",
          active: true,
        },
      ],
      fields: [
        {
          name: "no_traslado",
          title: "No. Traslado",
          sortField: "no_traslado",
          width: "5%",
        },
        {
          name: "empleado",
          title: "Empleado",
          sortField: "empleado",
          width: "15%",
        },
        {
          name: "fechac",
          title: "Fecha traslado",
          sortField: "fechac",
          width: "10%",
        },
        {
          name: "bodega_envia",
          title: "Bodega Envia",
          sortField: "bodega_envia",
          width: "10%",
        },
        {
          name: "bodega_recibe",
          title: "Bodega Recibe",
          sortField: "bodega_recibe",
          width: "10%",
        },
        {
          name: "estado",
          title: "Estado",
          sortField: "estado",
          width: "5%",
        },
         {
           name: "enviado",
           title: "Enviado",
           sortField: "estado",
           width: "5%",
         },
         {
           name: "usuario_envia",
           title: "Usuario envia",
           sortField: "estado",
           width: "5%",
         },
         {
           name: "recibido",
           title: "Recibido",
           sortField: "estado",
           width: "5%",
         },
         {
           name: "usuario_recibe",
           title: "Usuario Recibe",
           sortField: "estado",
           width: "5%",
         },
       
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          // width: "10%",
        },
      ],
      searchType: [
        {nombre: "No. Traslado", value: "no_traslado"},
        {nombre: "Empleado", value: "empleado"},
        {nombre: "Fecha traslado", value: "fecha"},
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "no_traslado",
      sortDesc: false,
      searchLabel: {nombre: "Traslado", value: "no_traslado"},
      filterLabel: {nombre: "Traslado", value: "no_traslado"},
      showModalL: false, //Loading
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      items: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formVenta: {
      nombre: {
        required,
        async isUnique(value) {
          if (value === "") return true;
          let response = await axios
              .get(
                  this.apiUrl +
                  "departamentos/nombre_repetido?nombre=" +
                  value +
                  "&id=" +
                  this.formVenta.id +
                  "&tienda=" +
                  this.formVenta.tiendaid.id,
                  {
                    headers: {"x-token": this.userT.token},
                  }
              )
              .catch(console.log);
          this.repit = response.data.msg;
          // console.log(response.data.msg);
          return response.data.msg;
        },
      },
      descripcion: {required},
      tiendaid: {required},
    },
  },
  async mounted() {
    // console.log('hola')
    
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {"x-token": usuario.token},
      })
          .then((res) => {
            if (res.data.success) {
              // this.$router.push("/");
            }
          })
          .catch(() => {
            this.logout();
            location.reload();
          });
    }
    await this.bodegasDisponibles();
    await this.iniciarTablaConFiltros();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    activarBuscadorFechas(search){
      // console.log(search);
      this.bandera_fecha = (search.value == "fecha") ? true : false;
      // console.log(this.bandera_fecha)
    },
    updateDisableDates(){
      let me = this;
      if(new Date(me.customFormatter(me.fecha_inicio)).getTime() > new Date(me.customFormatter(me.fecha_fin))){
          me.$refs.myDatepicker.clearDate();
          me.fecha_fin = '';
      }
      me.disabledDates.to = new Date(me.fecha_inicio);
    },
    // customFormatter(date) {
    //   return moment(date).format('YYYY-MM-DD');
    // },
    limpiarfiltro(){
        let me = this;
        me.fecha_inicio = "";
        me.fecha_fin = "";
    },
  
    anularVenta() {
      axios
          .put(
              process.env.VUE_APP_URL + "traslados/desactivate",
              {
                id: this.formVenta.id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.$refs.vuetable.refresh();
            this.$refs["modalAnular"].hide();
          
            Vue.toasted.error(
                "Traslado anulado",
                this.options
            );
       
            this.swAnular = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
      // .finally(() => {

      // });
    },
    enviarTraslado() {
      // console.log(this.formVenta.id);
      axios
          .put(
              process.env.VUE_APP_URL + "traslados/enviar_traslado",
              {
                id: this.formVenta.id,
                usuario: this.userT.name
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.$refs.vuetable.refresh();
            this.$refs["modalEnviar"].hide();
          
            Vue.toasted.error(
                "Traslado enviado",
                this.options
            );
       
            this.swAnular = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
      // .finally(() => {

      // });
    },
    recibirTraslado() {
      // console.log(this.formVenta.id);
      axios
          .put(
              process.env.VUE_APP_URL + "traslados/recibir_traslado",
              {
                id: this.formVenta.id,
                usuario: this.userT.name
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.$refs.vuetable.refresh();
            this.$refs["modalRecibir"].hide();
          
            Vue.toasted.error(
                "Traslado recibido",
                this.options
            );
       
            this.swAnular = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          });
      // .finally(() => {

      // });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").format("MMM Do YYYY");
    },
    showHour(date) {
      return moment(date).locale("es").format("MMM Do YYYY HH:mm");
    },
    validarFecha(fecha) {
      let hoy = moment(new Date());
      let vec = moment(fecha);
      if (hoy > vec) {
        return true;
      } else {
        return false;
      }
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
      this.persistFiltros();
      console.log(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },
    async changeTypeDates(fecha_inicio, fecha_fin) {
      // await this.separarfechas();
      this.fecha_inicio = fecha_inicio;
      this.fecha_fin = fecha_fin;
      this.$refs.vuetable.refresh();
    },
    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.fecha_inicio = type.value == "fecha" ? this.fecha_inicio : "";
      this.fecha_fin = type.value == "fecha" ?     this.fecha_fin : "";
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    changeTipoVenta(type) {
      this.tipo_label = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
          ? {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
                ? sortOrder[0].sortField
                : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            estado: this.tipo_label.value,
          }
          : {
            fecha_inicio: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            criterio: sortOrder[0]
                ? sortOrder[0].sortField
                : this.searchLabel.value,
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            estado: this.tipo_label.value,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    async bodegasDisponibles() {
      const tienda = this.userT.tienda;
      const response = await axios.get(
        process.env.VUE_APP_URL + "productos/bodegas_by_tienda?id=" + tienda,
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.arrayBodegas = response.data.bodegas;
      console.log(this.arrayBodegas);
      // console.log(   this.formPro.tienda );
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formVenta.id = 0;
      this.formVenta.descripcion = "";
      this.formVenta.nombre = "";
      this.formVenta.tiendaid = null;
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
        console.log(data)
      // if (action == "aprobar-item") {

        this.formVenta.descripcion =
            "Anulación de traslado el día " + this.showHour(new Date());

        this.formVenta.id = data.id;
      // }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst"/>

    <div class="row">
      <div class="col-12">
       

        <b-modal
            centered
            v-model="showModalL"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
            no-close-on-backdrop
            content-class="my-class"
            header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                      :animation-duration="2000"
                      :size="90"
                      color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
            centered
            id="modalAnular"
            ref="modalAnular"
            title="Anular traslado"
            title-class="text-black font-18"
            body-class="p-3"
            no-close-on-backdrop
        >
          <h4 align="center">
            <!-- ¿Desea agregar la cantidad
            <strong>{{ money(formVenta.total) }}</strong> al saldo del cliente
            <strong>{{ formVenta.cliente }}</strong
            >?
            <br/>
            <switches
                type-bold="true"
                text-enabled="SI"
                text-disabled="NO"
                v-model="swAnular"
            ></switches> -->
            <b-input
                v-model="formVenta.descripcion"
                placeholder="Ingrese una observación"
            ></b-input>
          </h4>
          <template #modal-footer="{}">
            <b-button variant="secondary" @click="$bvModal.hide('modalAnular')"
            >Cerrar
            </b-button
            >
            <b-button variant="danger" @click="anularVenta">Anular</b-button>
          </template>
        </b-modal>
        <b-modal
            centered
            id="modalEnviar"
            ref="modalEnviar"
            title="Enviar traslado"
            title-class="text-black font-18"
            body-class="p-3"
            no-close-on-backdrop
        >
          <!-- <h4 align="center">
            <b-input
                v-model="formVenta.descripcion"
                placeholder="Ingrese una observación"
            ></b-input>
          </h4> -->
          <template #modal-footer="{}">
            <b-button variant="secondary" @click="$bvModal.hide('modalAnular')"
            >Cerrar
            </b-button
            >
            <b-button variant="danger" @click="enviarTraslado">Enviar Traslado</b-button>
          </template>
        </b-modal>
        <b-modal
            centered
            id="modalRecibir"
            ref="modalRecibir"
            title="Enviar traslado"
            title-class="text-black font-18"
            body-class="p-3"
            no-close-on-backdrop
        >
          <!-- <h4 align="center">
            <b-input
                v-model="formVenta.descripcion"
                placeholder="Ingrese una observación"
            ></b-input>
          </h4> -->
          <template #modal-footer="{}">
            <b-button variant="secondary" @click="$bvModal.hide('modalRecibir')"
            >Cerrar
            </b-button
            >
            <b-button variant="danger" @click="recibirTraslado">Recibir Traslado</b-button>
          </template>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Traslados</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>
           

              <div class="col-sm-12 col-md-2">
                <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="changeTypeSearch(search), activarBuscadorFechas(search, index);"
                      >{{ search.nombre }}
                      </b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-2 text-md-start" v-if="!bandera_fecha">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                        v-model="search"
                        type="search"
                        @input="onFiltered()"
                        placeholder="Buscar..."
                        class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-4" v-if="!bandera_fecha">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <label class="d-inline-flex align-items-center">
                      <router-link
                          :to="{
                          name: 'nuevotraslado',
                        }"
                      >
                        <button
                            v-b-modal.modalSave
                            type="button"
                            class="btn btn-success btn-rounded mb-2 me-2"
                        >
                          <b>NUEVO TRASLADO</b>&nbsp;&nbsp;<i
                            class="bx bxs-plus-circle"
                        ></i>
                        </button>
                      </router-link>
                    </label>
                  </label>
                </div>
              </div>
                <!-- Campo de fecha de inicio -->
                <div class="col-sm-12 col-md-3" v-if="bandera_fecha">
                  <!-- <label for="startDate" class="form-label">Fecha de inicio:</label> -->
                  <datepicker :bootstrap-styling="true"
                   @input="updateDisableDates()" placeholder="Fecha inicio" 
                   :language="es" :format="customFormatter" v-model="fecha_inicio"></datepicker>
                </div>

                <!-- Campo de fecha de fin -->
                <div class="col-sm-12 col-md-3" v-if="bandera_fecha">
                  <!-- <label for="endDate" class="form-label">Fecha de fin:</label> -->
                  <datepicker :bootstrap-styling="true" @input="changeTypeDates(fecha_inicio, fecha_fin)"  ref="myDatepicker" 
                  placeholder="Fecha fin" :disabledDates="disabledDates" :language="es" :format="customFormatter" v-model="fecha_fin"></datepicker>

                </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <!-- Desktop (>= md): tabla -->
              <div class="d-none d-lg-block">
              <vuetable
                  ref="vuetable"
                  class="table-divided order-with-arrow"
                  :css="css.table"
                  :api-url="apiBase"
                  :reactive-api-url="true"
                  :fields="fields"
                  :per-page="perPage"
                  :http-options="httpOptions"
                  :query-params="makeQueryParams"
                  :load-on-start="false"
                  pagination-path
                  @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-dropdown
                      text="Opciones"
                      variant="outline-primary"
                      size="sm"
                  >
                 
                    <!-- Ver mas procesadas -->
                    <router-link
                        :to="{
                        name: 'detailtraslado',
                        params: {
                          id: props.rowData.id,
                          state: props.rowData.estado_traslado.toString(),
                        },
                      }"
                    >
                      <b-dropdown-item-button variant="outline-primary"
                      ><i class="bx bxs-show"></i>&nbsp;&nbsp;&nbsp;&nbsp;Ver
                        más
                      </b-dropdown-item-button>
                    </router-link>
                    <!-- Anular -->
                    <b-dropdown-item-button
                        v-if="
                        props.rowData.estado_traslado
                      "
                        v-b-modal.modalAnular
                        @click="onActionClicked('aprobar-item', props.rowData)"
                        variant="outline-danger"
                    ><i class="bx bx-block"></i>&nbsp;&nbsp;&nbsp;&nbsp;Anular
                      traslado
                    </b-dropdown-item-button>
                    <!-- Imprimir -->
                    <router-link
                      :to="{
                        name: 'comprobante_traslado',
                        params: { id: props.rowData.id },
                      }"
                    >
                      <b-dropdown-item-button
                        v-if="props.rowData.estado_traslado"
                        tabindex="0"
                        title="Imprimir"
                        variant="outline-secondary"
                        ><i class="bx bx-printer"></i
                        >&nbsp;&nbsp;&nbsp;&nbsp;Imprimir
                      </b-dropdown-item-button>
                    </router-link> 
                     <b-dropdown-item-button
                    v-if="!props.rowData.recibido"
                    v-b-modal.modalRecibir
                      @click="onActionClicked('firma-recibido', props.rowData)"
                      variant="outline-success"
                    >
                      <i class="bx bx-edit"></i>&nbsp;&nbsp;&nbsp;&nbsp;Firma de recibido
                    </b-dropdown-item-button>

                    <b-dropdown-item-button
                    v-if="!props.rowData.enviado"
                    v-b-modal.modalEnviar
                      @click="onActionClicked('firma-enviado', props.rowData)"
                      variant="outline-info"
                    >
                      <i class="bx bx-user-check"></i>&nbsp;&nbsp;&nbsp;&nbsp;Firma enviado
                    </b-dropdown-item-button> 
                  </b-dropdown>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_traslado == true">
                    <span class="badge bg-success ms-1"
                    ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="enviado" slot-scope="props">
                  <h5 v-if="props.rowData.enviado == true">
                    <span class="badge bg-success ms-1"
                    ><strong>Enviado</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>Pendiente entrega</strong></span
                    >
                  </h5>
                </div>
                <div slot="recibido" slot-scope="props">
                  <h5 v-if="props.rowData.recibido == true">
                    <span class="badge bg-success ms-1"
                    ><strong>Recibido</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>Pendiente recepción</strong></span
                    >
                  </h5>
                </div>

                <div slot="bodega_envia" slot-scope="props">
                    {{`${props.rowData.envia.tienda.nombre_tienda +' :: ' +props.rowData.envia.nombre_bodega}`}}
                </div>
                <div slot="bodega_recibe" slot-scope="props">
                    {{`${props.rowData.recibe.tienda.nombre_tienda +' :: '+props.rowData.recibe.nombre_bodega}`}}
                </div>
                <div slot="empleado" slot-scope="props">
                 
                    {{`${props.rowData.user.empleado.persona.nombre_persona} ${props.rowData.user.empleado.persona.apellido_persona}`}}
                 
                  <br/>
                </div>
                <div slot="fechac" slot-scope="props">
                  {{ props.rowData.fecha_traslado?showHour(props.rowData.fecha_traslado):showDate(props.rowData.fecha_traslado) }}
                </div>
              </vuetable>
              </div>

              <!-- Móvil (< md): cards -->
              <ResponsiveCards :items="items">
                <template #card="{ item }">
                  <div class="rwd-card__head">
                    <span v-if="item.estado_traslado == true" class="badge bg-success">ACTIVO</span>
                    <span v-else class="badge bg-danger">INACTIVO</span>
                    <b-dropdown text="Opciones" variant="outline-primary" size="sm" right>
                      <router-link :to="{ name: 'detailtraslado', params: { id: item.id, state: item.estado_traslado.toString() } }">
                        <b-dropdown-item-button variant="outline-primary"><i class="bx bxs-show"></i> Ver más</b-dropdown-item-button>
                      </router-link>
                      <b-dropdown-item-button
                        v-if="item.estado_traslado"
                        v-b-modal.modalAnular
                        @click="onActionClicked('aprobar-item', item)"
                        variant="outline-danger"><i class="bx bx-block"></i> Anular traslado</b-dropdown-item-button>
                      <router-link :to="{ name: 'comprobante_traslado', params: { id: item.id } }">
                        <b-dropdown-item-button
                          v-if="item.estado_traslado"
                          tabindex="0"
                          title="Imprimir"
                          variant="outline-secondary"><i class="bx bx-printer"></i> Imprimir</b-dropdown-item-button>
                      </router-link>
                      <b-dropdown-item-button
                        v-if="!item.recibido"
                        v-b-modal.modalRecibir
                        @click="onActionClicked('firma-recibido', item)"
                        variant="outline-success"><i class="bx bx-edit"></i> Firma de recibido</b-dropdown-item-button>
                      <b-dropdown-item-button
                        v-if="!item.enviado"
                        v-b-modal.modalEnviar
                        @click="onActionClicked('firma-enviado', item)"
                        variant="outline-info"><i class="bx bx-user-check"></i> Firma enviado</b-dropdown-item-button>
                    </b-dropdown>
                  </div>
                  <div class="rwd-card__title">Traslado {{ item.no_traslado }}</div>
                  <div class="rwd-card__sub">{{ `${item.envia.tienda.nombre_tienda} :: ${item.envia.nombre_bodega}` }} → {{ `${item.recibe.tienda.nombre_tienda} :: ${item.recibe.nombre_bodega}` }}</div>
                  <div class="d-flex flex-wrap gap-1 mt-1">
                    <span v-if="item.enviado == true" class="badge bg-success">Enviado</span>
                    <span v-else class="badge bg-danger">Pendiente entrega</span>
                    <span v-if="item.recibido == true" class="badge bg-success">Recibido</span>
                    <span v-else class="badge bg-danger">Pendiente recepción</span>
                  </div>
                  <div class="rwd-card__meta">
                    <span>{{ `${item.user.empleado.persona.nombre_persona} ${item.user.empleado.persona.apellido_persona}` }}</span>
                    <span>{{ item.fecha_traslado ? showHour(item.fecha_traslado) : showDate(item.fecha_traslado) }}</span>
                  </div>
                </template>
              </ResponsiveCards>

              <div style="padding-top: 10px">
                <vuetable-pagination
                    ref="pagination"
                    :css="css.pagination"
                    @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
